export const START_SINGLE_QUOTE_REGEX = /^['‘][\w\u00C0-\u00ff]+$/;
export const END_SINGLE_QUOTE_REGEX = /^[\w\u00C0-\u00ff]+['’]$/;
export const COMPOUNDED_ADJECTIVE_REGEX = /^[\w\u00C0-\u00ff]+-$/;
export const SPACES_REGEX = /\s+/;
export const THREE_DOT_REGEX = /(\.\.\.)/;
export const BOUNDARY_SPECIAL_EXTRACT_REGEX =
  /^(\W*)(.|[\w\u00D8-\u00F6]+.*[\w\u00D8-\u00F6]+)(\W*)$/;
export const NUMBER_REGEX = /^[0-9]+[0-9,.]+[0-9]+$/;
export const PHONE_NUMBER_REGEX = /^[0-9]+[0-9-]+[0-9]+$/;
export const ALL_SPECIAL_CHARACTERS_REGEX = /([^A-Za-z0-9\u00D8-\u00F6])/;
export const PUNCTUATION_REGEX = /^\W|\.\.\.$/u;
export const COMPOUND_WORD_REGEX = /^[\w\u00C0-\u00ff]+['’-][\w\u00C0-\u00ff]+$/;
export const MULTIPLE_SPECIAL_CHARACTERS = /^[^A-Za-z0-9\u00D8-\u00F6]+$/;
export const CAPTION_REGEX = new RegExp('<v\\s(.*)>(.*)');
export const REGEX_NUMBER = /^[0-9]+$/;
export const VIETNAMESE_REGEX =
  /à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|ì|í|ị|ỉ|ĩ|ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|ỳ|ý|ỵ|ỷ|ỹ|đ/g;

export const transliterate = (word) => {
  if (!word) {
    return '';
  }
  let answer = '';
  const a = {};

  a['Ё'] = 'YO';
  a['Й'] = 'I';
  a['Ц'] = 'TS';
  a['У'] = 'U';
  a['К'] = 'K';
  a['Е'] = 'E';
  a['Н'] = 'N';
  a['Г'] = 'G';
  a['Ш'] = 'SH';
  a['Щ'] = 'SCH';
  a['З'] = 'Z';
  a['Х'] = 'H';
  a['Ъ'] = "'";
  a['ё'] = 'yo';
  a['й'] = 'i';
  a['ц'] = 'ts';
  a['у'] = 'u';
  a['к'] = 'k';
  a['е'] = 'e';
  a['н'] = 'n';
  a['г'] = 'g';
  a['ш'] = 'sh';
  a['щ'] = 'sch';
  a['з'] = 'z';
  a['х'] = 'h';
  a['ъ'] = "'";
  a['Ф'] = 'F';
  a['Ы'] = 'I';
  a['В'] = 'V';
  a['А'] = 'A';
  a['П'] = 'P';
  a['Р'] = 'R';
  a['О'] = 'O';
  a['Л'] = 'L';
  a['Д'] = 'D';
  a['Ж'] = 'ZH';
  a['Э'] = 'E';
  a['ф'] = 'f';
  a['ы'] = 'i';
  a['в'] = 'v';
  a['а'] = 'a';
  a['п'] = 'p';
  a['р'] = 'r';
  a['о'] = 'o';
  a['л'] = 'l';
  a['д'] = 'd';
  a['ж'] = 'zh';
  a['э'] = 'e';
  a['Я'] = 'Ya';
  a['Ч'] = 'CH';
  a['С'] = 'S';
  a['М'] = 'M';
  a['И'] = 'I';
  a['Т'] = 'T';
  a['Ь'] = "'";
  a['Б'] = 'B';
  a['Ю'] = 'YU';
  a['я'] = 'ya';
  a['ч'] = 'ch';
  a['с'] = 's';
  a['м'] = 'm';
  a['и'] = 'i';
  a['т'] = 't';
  a['ь'] = "'";
  a['б'] = 'b';
  a['ю'] = 'yu';

  for (const i in word) {
    if (String.prototype.hasOwnProperty.call(word, i)) {
      if (a[word[i]] === undefined) {
        answer += word[i];
      } else {
        answer += a[word[i]];
      }
    }
  }
  return answer;
};
